<template>
  <div class="box">
    <div class="box-body h-300 text-center">
      <i class="text-primary fs-80 fas fa-calendar-times mt-55"></i>
      <h4 class="text-muted mt-3">No Visit on This Date</h4>
    </div>
  </div>
</template>